import { render, staticRenderFns } from "./WootKeyShortcutModal.vue?vue&type=template&id=747d5923&scoped=true&"
import script from "./WootKeyShortcutModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./WootKeyShortcutModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./WootKeyShortcutModal.vue?vue&type=style&index=0&id=747d5923&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747d5923",
  null
  
)

export default component.exports